module.exports = __webpack_public_path__ + "img/status-waiting.feba7f4d.svg";